import { THIS_SCHOOL_YEAR } from './components/date-picker-trans/date-picker-constants';
import { UPDATE_SELECTED_DATE_RANGE } from './date-picker-actions';

const currentDateRangeAndType = {
    type: THIS_SCHOOL_YEAR,
    startDate: null,
    endDate: null
};
const initialState = {
    ...currentDateRangeAndType
};

/**
 * DatePicker Reducer
 *
 * Consumes UPDATE_SELECTED_DATE_RANGE action
 * Consumes UPDATE_CLASS_DETAILS_DATE_RANGE action
 * Consumes UPDATE_CERTIFICATES_DATE_RANGE action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - date type, start and end dates of selected range for each page
 */
export default function (state = initialState, action) {
    if (!action) return state;
    const { type, payload } = action;
    switch (type) {
    case UPDATE_SELECTED_DATE_RANGE:
        return {
            ...payload
        };

    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./components/date-picker/date-picker-reducer.js